<template>
  <BaseGridView
    endpoint="v1/SupplierSubledgerEntry/GetData"
    :pageTitle="$t('Supplier SubLedger Entries')"
    :columnDef="(columnDef as Array<ColumnModel>)"
    :searchOptions="_searchOptions"
  >
  </BaseGridView>
</template>

<script lang="ts" setup>
import { ColumnModel } from "@syncfusion/ej2-vue-grids";
import { getCurrentInstance, onBeforeMount, ref } from "vue";
import BaseGridView from "../../common/BaseGridView.Component.vue";
import { SearchOption } from "../../common/CommonInterfaces";
import { GridConfig } from "../../common/Constants";

let columnDef = ref([] as ColumnModel[]);
const _searchOptions = {
  fields: [
    "company.Name",
    "supplierName",
    "supplierAccountNo",
    "amount",
    "balance",
    "currencyAmount",
    "currencyCode",
    "dueDate",
    "invoiceNo",
    "postingDate",
    "projectCode",
    "voucherDate",
    "voucherNo",
  ],

  operator: "contains",
  ignoreCase: true,
} as SearchOption;

const app = getCurrentInstance();

onBeforeMount(() => {
  assignColumnDef();
});

const assignColumnDef = () => {
  const instance = app?.proxy;
  columnDef.value = [
    {
      field: "companyName",
      headerText: instance?.$t("companyName"),
      textAlign: "Center",
      freeze: "Left",
      width: 200,
    },
    {
      field: "amount",
      headerText: instance?.$t("amount"),
    },
    { field: "balance", headerText: instance?.$t("balance") },
    { field: "currencyAmount", headerText: instance?.$t("currencyAmount") },
    { field: "currencyCode", headerText: instance?.$t("currencyCode") },
    {
      field: "supplierAccountNo",
      headerText: instance?.$t("supplierAccountNo"),
    },
    { field: "supplierName", headerText: instance?.$t("supplierName") },
    {
      field: "dueDate",
      headerText: instance?.$t("dueDate"),
      type: "date",
      format: GridConfig.dateFormat,
    },
    { field: "invoiceNo", headerText: instance?.$t("invoiceNo") },
    {
      field: "postingDate",
      headerText: instance?.$t("postingDate"),
      type: "date",
      format: GridConfig.dateFormat,
    },
    { field: "projectCode", headerText: instance?.$t("projectCode") },
    {
      field: "voucherDate",
      headerText: instance?.$t("voucherDate"),
      type: "date",
      format: GridConfig.dateFormat,
    },
    { field: "voucherNo", headerText: instance?.$t("voucherNo") },
  ];
};
</script>
